export default __webpack_public_path__ + "static/media/LegoWedo.43066940.webp";